import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    className?: string;
    /**
     * Optional action slot rendered to the right of the title on the
     * same row. Used e.g. for the OHD-launch "Reschedule" CTA on the
     * patient dashboard. Wraps below the title on narrow viewports
     * so the heading itself stays prominent.
     */
    rightAction?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({title, subtitle, className, rightAction}) => {
    const wrapperClass = className ?? 'my-8';
    return (
        <div className={wrapperClass}>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
                <h1 className="text-5xl font-light text-mld-text-primary tracking-tight">{title}</h1>
                {rightAction ? <div className="flex shrink-0 items-center">{rightAction}</div> : null}
            </div>
            {subtitle && <p className="text-xl text-mld-text-secondary mt-2">{subtitle}</p>}
        </div>
    );
};

export default PageHeader;
